export default "/images/vendor/@coreui/icons/svg/flag/cif-mn.svg?965f150a78cd4a8a8e29cd0a677b9bf4";